
import base from "./base.service";

const instance = base.service(); 


export const getAll = () => {
    return instance.get("/clanak/all"); 
};
export const getByNaziv = (naslov) => {
    return instance.get(`/clanak/naslov/${naslov}`);
};

export const deleteClanak = (id) =>
{
    return instance.delete(`/clanak/brisanje/${id}`);
}

export const addClanak = (noviClanak) =>
{
    return instance.post(`/clanak`, noviClanak);
}

const getGalerija = (id) => {
  return instance.get(`/clanak/${id}/galerija`);
};



export const updateClanak = (id, formData) => {
  return instance.put(`/clanak/form/${id}`, formData, {
    headers: {
      "Content-Type": "multipart/form-data"
    }
  });
};

export const getById = (id) =>
{
    return instance.get(`/clanak/${id}`);
}

export const getClanciByKategorijaId = (idKategorije) =>
    {
        return instance.get(`/clanak/kategorija/${idKategorije}`);
    }

    export const uploadClanak = (formData) => {
        return instance.post("/clanak/upload", formData, {
            headers: {
                "Content-Type": "multipart/form-data"
            }
        });
    };

export default {
    getAll, getByNaziv,deleteClanak,addClanak, getById, uploadClanak, updateClanak, getClanciByKategorijaId,getGalerija
}
